import { useIsAuthenticated } from '@refinedev/core';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    const { data, isLoading } = useIsAuthenticated();
    const isAuthenticated = data?.authenticated;
    const location = useLocation();

    if (isLoading) {
        return (
            <Spin
                size="large"
                style={{
                    display: 'block',
                    margin: 'auto',
                    marginTop: '20vh',
                }}
            />
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};
